import React from 'react';
import Nav from './components/Nav';
import Hero from './components/Hero';
import Features from './components/Features';
import Menu from './components/Menu';
import Gallery from './components/Gallery';
import About from './components/About';
import Testimonials from './components/Testimonials';
import Reservation from './components/Reservation';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <div className="App">
      <Nav />
      <Hero />
      <Features />
      <Menu />
      <Gallery />
      <About />
      <Testimonials />
      <Reservation />
      <Footer />
    </div>
  );
}

export default App;
